import React, { } from "react";
import HelpWindow from "./HelpWindow";
import { Typography } from "@mui/material";

export const HelpFPSCRates = () => {
    return (
        <Typography variant="body1" gutterBottom>
            FPSC Guideline (2023)<br />
            <li>Cash: 2.3%</li>
            <li>Fixed Income: 3.2%</li>

            <li>Canadian Investments: 6.2%  (~33% Dividend)</li>
            <li>Foreign Investments: 6.5%</li>
            <li>Emerging Investments: 7.4%</li>

            <li>Borrowing: 4.3%</li>
            <li>Inflation: 2.1%</li>
            <br />


        </Typography>
    )
}

export const HelpQuickStart = () => {
    return (
        <HelpWindow title="Client QuickStart" >
            <Typography variant="body1" gutterBottom>
                This screen is for quickly adding a client and a typical set of accounts values to quickly get up and running.<br />
                Later you can edit the client and add more information about the client or their accounts.<br />
                For example you might want to enter Employer matching programs, multiple Non-Registered accounts, or different rates, setup the cost basis or children/Education RESP's or a Defined Benefit Pension Plan etc.<br />
                Assumptions are 50% of the Expenses, Home, Home Mortgage and Payment will be attributed to the Spouse, all of which can be changed later.<br />
                <br />
                You can save the entries and then go edit more accounts or other details and then run the scenario.<br />
                Or you run the scenario from here and then add other information to that scenario.<br />
                <br />
                <HelpFPSCRates />

            </Typography>
        </HelpWindow>
    )
}

export const HelpQuickUpdate = () => {
    return (
        <HelpWindow title="QuickUpdate" >
            <Typography variant="body1" gutterBottom>
                This screen is for quickly adding new values for the new year.  Typically you would do this in Jan of a year for the previous year.  <br />
                You can also enter the current year and month for mid year updates.  <br />
                For midyear monthly updates the scenario will use the new value and pro-rate any earnings/payments for the rest of the year.  For example if you enter August, then the system will use 4/12 (Sept-Dec) of any 'return/payment' to update to the end of the year. <br />
                Month updates:
                <li> assume end of the given month</li>
                <li> only 1 month is allowd for the current year. Fetch of that year will return the current data /month if it exists, Submit will override those entries.</li>
                <br />
                Note: you may need to update more than the single value in the account, For example a new Interest Rate, for liabilities or Cash account, in which case you may enter information here then enter additional changes to the specific accounts.<br />
            </Typography>
        </HelpWindow>
    )
}